import React, { useEffect, useState } from "react";
import { CardText, Row, Col, Modal, ModalHeader } from "reactstrap";
import "assets/scss/website/app.scss";
import Select from "react-select";
import "react-rangeslider/lib/index.css";
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "react-multi-carousel/lib/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters, resetFilters } from "store/filter/actions";
import "./styles.scss";
import RoomFilter from "./RoomFilter";
import HomeService from "services/Website/HomeService";
import { SuccessOk } from "configs/statusCode";
import { useTranslation } from "react-i18next";
import { paymentOptions } from "Enums/fixedData";
import AreasService from "services/Admin/AreasService";
import UnitTypesService from "services/Admin/UnitTypesService";
import FinishingTypesService from "services/Admin/FinishingTypesService";
import CategoriesService from "services/Admin/CategoriesService";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import filterIcon from "../../../assets/images/filter.svg";

const SideFilters = ({
	updateFilterHandler,
	type,
	setOpenSearch,
	setLoading,
	loading,
	modal,
	history,
	toggle,
}) => {
	const filterData = useSelector((state) => state.filter);
	const AuthData = useSelector((state) => state.Auth);
	const lang = useSelector((state) => state.Auth?.lang);
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [locationOptions, setLocationOptions] = useState([]);
	const [unitTypeOptions, setUnitTypeOptions] = useState([]);
	const [finishingOptions, setFinishingOptions] = useState([]);
	const [categortiesOptions, setCategortiesOptions] = useState([]);
	const location = useLocation();
	const areaService = new AreasService();
	const unitTypesService = new UnitTypesService();
	const finishingTypesService = new FinishingTypesService();
	const categoriesService = new CategoriesService();

	const showLoading = () => setLoading(true);

	const formatParamsHandler = (data) => {
		let value = "";
		for (let i = 0; i < data.length; i++) {
			if (i === 0) {
				value = data[i].value;
			} else {
				value = `${value},${data[i].value}`;
			}
		}
		return value;
	};

	const getSelectData = (service, setData, type) => {
		service.getDropDown().then((res) => {
			const data = res.data.map((item) => {
				return {
					name: item.name,
					label: item.name[`${AuthData.lang}`]
						? item.name[`${AuthData.lang}`]
						: item.name.en,
					value: item.id,
				};
			});
			setData(data);

			if (type === "unitTypeOptions") {
				dispatch(appendFilters({ unitTypeOptions: data }));
			}
			if (type === "finishingOptions") {
				dispatch(appendFilters({ finishingOptions: data }));
			}
			if (type === "categortiesOptions") {
				dispatch(appendFilters({ CategortiesOptions: data }));
			}
		});
	};

	useEffect(() => {
		getSelectData(unitTypesService, setUnitTypeOptions, "unitTypeOptions");
		getSelectData(
			finishingTypesService,
			setFinishingOptions,
			"finishingOptions"
		);
		getSelectData(areaService, setLocationOptions, "locationOptions");
		getSelectData(
			categoriesService,
			setCategortiesOptions,
			"categortiesOptions"
		);
	}, []);

	// useEffect(() => {
	//     let params = {}
	//     params["budget"] = `${filterData.budget[0]}-${filterData.budget[1]}`
	//     params["area_sizs"] = `${filterData.size[0]}-${filterData.size[1]}`
	//     if (filterData.bedrooms?.length) params["bedrooms"] = filterData.bedrooms.join()
	//     if (filterData.bathrooms?.length) params["bathrooms"] = filterData.bathrooms.join()
	//     if (filterData.paymentMethod) params["payment_type"] = filterData.paymentMethod
	//     if (filterData.categories_ids.length) params["category_ids"] = formatParamsHandler(filterData.categories_ids)
	//     if (filterData.finishingType.length) params["finishing_type_ids"] = formatParamsHandler(filterData.finishingType)
	//     if (filterData.unitType.length) params["unit_type_ids"] = formatParamsHandler(filterData.unitType)
	//     // updateFilterHandler(params)
	// }, [filterData])

	const onSlide = (...rest) => {
		dispatch(appendFilters({ budget: rest[0] }));
		showLoading();
	};

	const onSlideSize = (...rest) => {
		dispatch(appendFilters({ size: rest[0] }));
		showLoading();
	};

	useEffect(() => {
		const params = {};
		params["type"] = type === "Resale" ? "resale" : "unit";
		new HomeService().getRangeFilter(params).then((response) => {
			if (response && response.status === SuccessOk) {
				dispatch(
					appendFilters({
						budgetRange:
							response.data.minPrice == response.data.maxPrice
								? [1, response.data.maxPrice]
								: [response.data.minPrice, response.data.maxPrice],
						sizeRange:
							response.data.minSize == response.data.maxSize
								? [1, response.data.maxSize]
								: [response.data.minSize, response.data.maxSize],
						budget: [response.data.minPrice, response.data.maxPrice],
						size: [response.data.minSize, response.data.maxSize],
						getRanges: true,
					})
				);
				// showLoading()
			}
		});
	}, [type]);

	return (
		<Modal isOpen={modal} toggle={toggle} className="custom-filter p-3">
			<div className="title">
				<div className="d-flex" style={{ gap: "8px" }}>
					<img src={filterIcon} alt="filterIcon" />
					<span className="gotham-font">Filter By</span>
				</div>
				<i className="fa fa-times cursor-pointer" onClick={toggle} />
			</div>
			{loading ? (
				<div
					style={{
						opacity: ".6",
						zIndex: 300,
						background: "#ffffff",
						position: "absolute",
						width: "100%",
						height: "100%",
						top: 0,
						left: 0,
					}}></div>
			) : null}
			<AvForm>
				{type === "Compound" && (
					<div className="mt-2">
						<label className="fw-bold">{t("Compound Name")}</label>
						<AvField
							name="name"
							id={"compoundNamme"}
							placeholder={t("Compound Name")}
							className="fotm-control btnHeight mb-2"
							value={
								typeof filterData.compound === "string"
									? filterData.compound
									: filterData.compound?.label
							}
							onChange={(e) => {
								dispatch(appendFilters({ compound: e.target.value }));
							}}
						/>
					</div>
				)}
				{type === "Resale" && (
					<div>
						<label className="fw-bold">{t("Resale Name")}</label>
						<AvField
							id={"resaleNamme"}
							name="resale name"
							placeholder={t("Resale Name")}
							className="fotm-control btnHeight mb-2"
							value={
								typeof filterData.resale === "string"
									? filterData.resale
									: filterData?.resale?.label
							}
							onChange={(e) => {
								dispatch(appendFilters({ resale: e.target.value }));
							}}
						/>
					</div>
				)}
				{type === "Unit" && (
					<div>
						<label className="fw-bold">{t("Unit Code")}</label>
						<AvField
							id={"propertyNamme"}
							name="Unit Code"
							placeholder={t("Unit Code")}
							className="fotm-control btnHeight mb-2"
							value={filterData.unit}
							onChange={(e) => {
								dispatch(appendFilters({ unit: e.target.value }));
							}}
						/>
					</div>
				)}
				<Row className="mt-4">
					<Col md={6}>
						<label className="mb-3 fw-bold">{t("Select Location")}</label>
						{locationOptions?.map((location) => {
							return (
								<label className="select">
									<input
										type="radio"
										name="location"
										checked={
											location?.value ===
											(type === "Compound"
												? filterData?.location?.value
												: filterData.ResaleLocation?.value)
										}
										onChange={() => {
											if (type === "Compound") {
												dispatch(appendFilters({ location: location }));
											} else {
												dispatch(appendFilters({ ResaleLocation: location }));
											}
											showLoading();
										}}
									/>
									{location?.name[lang]}
								</label>
							);
						})}
					</Col>
					<Col md={6}>
						<label className="mb-3 fw-bold">{t("property type")}</label>
						{unitTypeOptions?.map((type) => {
							return (
								<label
									className="select"
									onClick={() => {
										const isExist = filterData.unitType.some(
											(item) => item?.value === type?.value
										);
										if (!isExist) {
											dispatch(
												appendFilters({
													unitType: [...filterData.unitType, type],
												})
											);
										} else {
											const updatedData = filterData.unitType.filter(
												(item) => item.value !== type?.value
											);
											dispatch(appendFilters({ unitType: [...updatedData] }));
										}
										showLoading();
									}}>
									{/* <input
										type="checkbox"
										name={type?.value}
										checked={filterData.unitType?.some(
											(item) => item?.value === type?.value
										)} */}
									<span
										type="checkbox"
										name={type?.value}
										className={
											filterData.unitType?.some(
												(item) => item?.value === type?.value
											)
												? "checkbox-input active"
												: "checkbox-input"
										}></span>
									{type?.name[lang]}
								</label>
							);
						})}
					</Col>
				</Row>
				{type === "Compound" && (
					<>
						<label className="fw-bold">{t("Delivery")}</label>
						<AvField
							id={"delivery"}
							name="Delivery Date"
							className="form-control btnHeight mb-2"
							placeholder={t("Delivery")}
							value={filterData.delivery}
							onChange={(e) => {
								dispatch(appendFilters({ delivery: e.target.value }));
							}}
							type="number"
							pattern="\d+"
							min={new Date().getFullYear()}
						/>
					</>
				)}
				{/* {type === "Compound" && (
					<>
						<Select
							name="Location"
							placeholder={t("location")}
							options={locationOptions}
							onChange={(data) => {
								dispatch(appendFilters({ location: data }));
								showLoading();
							}}
							className="mb-3"
							bsSize="lg"
							value={filterData.location}
						/>
					</>
				)}
				{type === "Resale" && (
					<>
						<label className="fw-bold">{t("location")}</label>
						<Select
							name="Location"
							className=" mb-2"
							bsSize="lg"
							placeholder={t("location")}
							options={locationOptions}
							value={filterData.ResaleLocation}
							onChange={(data) => {
								dispatch(appendFilters({ ResaleLocation: data }));
								showLoading();
							}}
						/>
					</>
				)} */}
				{/* {type === "Unit" && <hr />}
				<CardText tag="h6" className="fw-bold pt-3">
					{t("property type")}
				</CardText>
				<div className="d-block btn-group-toggle" data-toggle="buttons">
					{unitTypeOptions?.map((type, index) => {
						return (
							<span key={index}>
								<input
									type="checkbox"
									className="btn-check"
									name="UnitType"
									id={`btncheckType${index}`}
									autoComplete="off"
									checked={filterData.unitType?.some(
										(item) => item.label === type?.label
									)}
									onChange={() => {}}
								/>
								<label
									onClick={() => {
										const isExist = filterData.unitType.some(
											(item) => item.label === type?.label
										);
										if (!isExist) {
											dispatch(
												appendFilters({
													unitType: [...filterData.unitType, type],
												})
											);
											showLoading();
										} else {
											const updatedData = filterData.unitType.filter(
												(item) => item.label !== type?.label
											);
											dispatch(appendFilters({ unitType: [...updatedData] }));
											showLoading();
										}
									}}
									className="btn btn-outline-light    me-2"
									style={{
										background: filterData.unitType.some(
											(item) => item.label === type?.label
										)
											? "#0583f2"
											: "#f5f5f5",
										color: filterData.unitType.some(
											(item) => item.label === type?.label
										)
											? "#fff"
											: "#000",
									}}
									htmlFor="UnitType">
									{type.label}
								</label>
							</span>
						);
					})}
				</div> */}
				{type == "Resale" && (
					<Col md={6}>
						<label className="mb-3 fw-bold">{t("Payment Method")}</label>
						{paymentOptions?.map((item, index) => {
							if (item.en === "Owner Installment" && type !== "Resale") {
								return;
							}
							return (
								<label
									className="select"
									onClick={() => {
										const isExist = filterData.paymentMethods?.some(
											(itemData) => itemData === item.en
										);
										if (!isExist) {
											dispatch(
												appendFilters({
													paymentMethods: [
														...filterData.paymentMethods,
														item.en,
													],
												})
											);
											showLoading();
										} else {
											const updatedData = filterData.paymentMethods.filter(
												(itemData) => itemData !== item.en
											);
											dispatch(
												appendFilters({
													paymentMethods: [...updatedData],
												})
											);
											showLoading();
										}
									}}>
									<span
										className={
											filterData.paymentMethods?.some(
												(itemData) => itemData === item?.en
											)
												? "checkbox-input active"
												: "checkbox-input"
										}></span>
									{item.en === "Owner Installment"
										? t("Installment with Owner")
										: item[`${AuthData.lang}`]}
								</label>
							);
						})}
					</Col>
				)}
				<label className="fw-bold mt-3">{t("finishing")}</label>
				<div className="d-block mb-4" data-toggle="buttons">
					<Select
						name="Location"
						className=" mb-2"
						bsSize="lg"
						placeholder={t("finishing")}
						options={finishingOptions}
						value={filterData.finishingType}
						isMulti
						onChange={(data) => {
							dispatch(appendFilters({ finishingType: data }));
							showLoading();
						}}
					/>
					{/* {finishingOptions?.map((type, index) => {
						return (
							<span key={index + 1}>
								<input
									type="checkbox"
									className="btn-check"
									name="typeFinish"
									id={`typeFinish${index + 1}`}
									autoComplete="off"
									checked={filterData.finishingType?.some(
										(item) => item.label === type?.label
									)}
									onChange={() => {}}
								/>
								<label
									style={{
										background: filterData.finishingType.some(
											(item) => item.label === type?.label
										)
											? "#0583f2"
											: "#f5f5f5",
										color: filterData.finishingType.some(
											(item) => item.label === type?.label
										)
											? "#fff"
											: "#000",
									}}
									onClick={() => {
										const isExist = filterData.finishingType.some(
											(item) => item.label === type?.label
										);
										if (!isExist) {
											dispatch(
												appendFilters({
													finishingType: [...filterData.finishingType, type],
												})
											);
											showLoading();
										} else {
											const updatedData = filterData.finishingType.filter(
												(item) => item.label !== type?.label
											);
											dispatch(
												appendFilters({ finishingType: [...updatedData] })
											);
											showLoading();
										}
									}}
									className="btn btn-outline-light me-2"
									htmlFor="btncheckType">
									{type.label}
								</label>
							</span>
						);
					})} */}
				</div>

				{type !== "Resale" && (
					<>
						<label className="fw-bold mt-3">{t("Categories")}</label>
						<div className="d-block pt-1 mb-4">
							<Select
								name="Location"
								className=" mb-2"
								bsSize="lg"
								placeholder={t("categories")}
								options={categortiesOptions}
								value={filterData.categories_ids}
								isMulti
								onChange={(data) => {
									dispatch(appendFilters({ categories_ids: data }));
									showLoading();
								}}
							/>
							{/* {categortiesOptions?.map((type, index) => {
								return (
									<span key={index}>
										<input
											type="checkbox"
											className="btn-check"
											name="typeCatogory"
											id={`typeCatogory${index}`}
											autoComplete="off"
											onChange={() => {}}
											checked={filterData.categories_ids?.some(
												(item) => item.label === type?.label
											)}
										/>
										<label
											style={{
												background: filterData.categories_ids.some(
													(item) => item.label === type?.label
												)
													? "#0583f2"
													: "#f5f5f5",
												color: filterData.categories_ids.some(
													(item) => item.label === type?.label
												)
													? "#fff"
													: "#000",
											}}
											onClick={() => {
												const isExist = filterData.categories_ids.some(
													(item) => item.label === type?.label
												);
												if (!isExist) {
													dispatch(
														appendFilters({
															categories_ids: [
																...filterData.categories_ids,
																type,
															],
														})
													);
													showLoading();
												} else {
													const updatedData = filterData.categories_ids.filter(
														(item) => item.label !== type?.label
													);
													dispatch(
														appendFilters({ categories_ids: [...updatedData] })
													);
													showLoading();
												}
											}}
											className="btn btn-outline-light me-2"
											htmlFor="btncheckType">
											{type.label}
										</label>
									</span>
								);
							})} */}
						</div>
					</>
				)}

				<label className="fw-bold mt-3">{t("Bedrooms")}</label>
				<div className="d-block btn-group-toggle" data-toggle="buttons">
					<RoomFilter roomsType={"bedrooms"} showLoading={showLoading} />
				</div>

				<label className="fw-bold mt-4">{t("Bathrooms")}</label>
				<div className="d-block btn-group-toggle" data-toggle="buttons">
					<RoomFilter roomsType={"bathrooms"} showLoading={showLoading} />
				</div>
				{type === "Resale" && (
					<>
						<label className="fw-bold mt-4">{t("Floor")}</label>
						<div className="d-block btn-group-toggle" data-toggle="buttons">
							<RoomFilter roomsType={"floor"} showLoading={showLoading} />
						</div>
					</>
				)}

				<div className="mt-5">
					<label className="fw-bold">
						{t("Square Meter")} ({t("M2")})
					</label>
					<Row>
						<Col md={6}>
							<AvField
								name="square"
								type="number"
								min="1"
								placeholder={t("Min")}
								className="fotm-control btnHeight mb-2"
								value={filterData.size[0]}
								onChange={(e) => {
									dispatch(
										appendFilters({
											size: [Number(e.target.value), filterData.size[1]],
										})
									);
								}}
							/>
						</Col>
						<Col md={6}>
							<AvField
								name="square"
								type="number"
								min="1"
								placeholder={t("Max")}
								className="fotm-control btnHeight mb-2"
								value={filterData.size[1]}
								onChange={(e) => {
									dispatch(
										appendFilters({
											size: [filterData.size[0], Number(e.target.value)],
										})
									);
								}}
							/>
						</Col>
					</Row>
					{/* <Row className=" d-flex justify-content-between mb-2">
						<Col md={6}>
							<span className="fw-bold font-size-14 text-muted">
								{Math.round(filterData.size[0])}
							</span>
						</Col>
						<Col md={6} className="d-flex flex-row-reverse p-0 text-muted">
							<span className="fw-bold font-size-14">
								{Math.round(filterData.size[1])}
							</span>
						</Col>
					</Row> */}
					{/* {AuthData.lang === "ar" ? (
						<Nouislider
							range={{
								// min: ,
								max: filterData.sizeRange[1],
							}}
							tooltips={false}
							step={10}
							start={filterData.size}
							connect
							onSlide={onSlideSize}
							direction={"rtl"}
						/>
					) : null}
					{AuthData.lang !== "ar" ? (
						<Nouislider
							range={{
								min: filterData.sizeRange[0],
								max: filterData.sizeRange[1],
							}}
							tooltips={false}
							step={10}
							start={filterData.size}
							connect
							onSlide={onSlideSize}
							direction={"ltr"}
						/>
					) : null} */}
				</div>
				<div className="mt-4">
					<label className="fw-bold">{t("Price Range")}</label>
					<Row>
						<Col md={6}>
							<AvField
								name="budget"
								type="number"
								min="1"
								placeholder={t("Min")}
								className="fotm-control btnHeight mb-2"
								value={filterData.budget[0]}
								onChange={(e) => {
									dispatch(
										appendFilters({
											budget: [Number(e.target.value), filterData.budget[1]],
										})
									);
								}}
							/>
						</Col>
						<Col md={6}>
							<AvField
								name="budget"
								type="number"
								min="1"
								placeholder={t("Max")}
								className="fotm-control btnHeight mb-2"
								value={filterData.budget[1]}
								onChange={(e) => {
									dispatch(
										appendFilters({
											budget: [filterData.budget[0], Number(e.target.value)],
										})
									);
								}}
							/>
						</Col>
					</Row>
					{/* <Row className=" d-flex justify-content-between mb-2">
						<Col md={6}>
							<span className="fw-bold font-size-14 text-muted">
								{toCurrency(filterData.budget[0])}{" "}
							</span>
						</Col>
						<Col md={6} className="d-flex flex-row-reverse p-0 text-muted">
							<span className="fw-bold font-size-14">
								{" "}
								{toCurrency(filterData.budget[1])}{" "}
							</span>
						</Col>
					</Row>
					{AuthData.lang === "ar" ? (
						<Nouislider
							range={{
								min: filterData.budgetRange[0],
								max: filterData.budgetRange[1],
							}}
							step={5000}
							tooltips={false}
							start={filterData.budget}
							connect
							onSlide={onSlide}
							direction={"rtl"}
						/>
					) : null}
					{AuthData.lang !== "ar" ? (
						<Nouislider
							range={{
								min: filterData.budgetRange[0],
								max: filterData.budgetRange[1],
							}}
							step={5000}
							tooltips={false}
							start={filterData.budget}
							connect
							onSlide={onSlide}
							direction={"ltr"}
						/>
					) : null} */}
				</div>
				<br />
				<div
					className="mt-4 d-flex justify-content-end"
					style={{ marginBottom: "30px" }}>
					<button
						className="btn shadow-none rest-Btn font-size-14 px-0 "
						type="button"
						onClick={() => {
							dispatch(resetFilters());
							if (type === "Compound") history.push(location?.pathname);
							showLoading();
						}}>
						{t("reset all")}
					</button>
				</div>
			</AvForm>
		</Modal>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
const getFixed = (number) => number.toFixed(0);

export default SideFilters;
